import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Page, PageHeader } from "../../../components/ui";
import ContentInfoForm, { contentPayload } from "./ContentInfoForm";

/**
 * "Add" page of a movie / TV show / podcast: creates the content with the
 * redux `createAction`, then opens its edit page (`editPath(id)`) where the
 * media are uploaded.
 *
 * - `savedKey`: response field holding the created content
 * - `extraPayload`: type specific request fields
 * - `missingKey`: message shown when a required field is empty
 */
const AddContentPage = ({
  title,
  genreType,
  extraPayload,
  createAction,
  savedKey,
  editPath,
  missingKey,
  successKey,
  cancelPath,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = async (values) => {
    const response = await dispatch(
      createAction(contentPayload(values, extraPayload))
    );
    const id = response && response[savedKey]?._id;
    if (!id) {
      toast.error(t("Error In General Content"));
      return;
    }
    toast.success(t(successKey));
    history.push(editPath(id));
  };

  return (
    <Page>
      <PageHeader
        title={t(title)}
        subtitle={t("You will upload the media on the next step")}
      />
      <ContentInfoForm
        genreType={genreType}
        extraPayload={extraPayload}
        missingKey={missingKey}
        onSubmit={handleSubmit}
        submitLabel={t("submit")}
        cancelPath={cancelPath}
      />
    </Page>
  );
};

export default AddContentPage;
